import { Route, Routes } from 'react-router-dom'
import { GuestResolverPage } from './guestResolver.page'
// Splits the routes into two, one for the guest resolver and one for the rest of the app
// we want to avoid providers dependencies in the guest resolver
export const GuestRoutesSplit = (props: { children: React.ReactNode }) => {
    return (
        <Routes>
            <Route path="/guest/*" element={<GuestResolverPage />} />
            <Route path="/*" element={props.children} />
        </Routes>
    )
}
